<script setup lang="ts">
import { useConfigurator } from '@/composables/configurator/useConfigurator'

const { conversationFlow, inactivity } = useConfigurator()
</script>

<template>
  <ConversationalFlow
    v-model="conversationFlow"
    v-model:inactivity="inactivity"
    data-testid="cf-tab-content"
  />
</template>
